import { render, staticRenderFns } from "./leifeng-shoplist.vue?vue&type=template&id=ef732fe8&scoped=true&"
import script from "./leifeng-shoplist.vue?vue&type=script&lang=js&"
export * from "./leifeng-shoplist.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-shoplist.vue?vue&type=style&index=0&id=ef732fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef732fe8",
  null
  
)

export default component.exports